var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listing-progress-outer"},[_c('div',{staticClass:"listing-progress-wrapper"},[_c('div',{staticClass:"listing-progress",style:({'width': _vm.progress, 'background': _vm.bgColor})})])])}
var staticRenderFns = []

export { render, staticRenderFns }